// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — PageHeader
// Consistent page header with icon, title, description, and actions
// ══════════════════════════════════════════════════════════════════════════════

import { useTheme } from '@contexts/ThemeContext';

export function PageHeader({ icon, title, description, actions }) {
  const { theme } = useTheme();

  return (
    <div style={{
      marginBottom: 28,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 16
    }}>
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          {icon}
          <h2 style={{
            margin: 0,
            fontSize: 22,
            fontWeight: 800,
            color: theme.text,
            letterSpacing: -0.3
          }}>
            {title}
          </h2>
        </div>
        {description && (
          <p style={{
            margin: '4px 0 0',
            fontSize: 13,
            color: theme.textSecondary,
            lineHeight: 1.6
          }}>
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {actions}
        </div>
      )}
    </div>
  );
}
